<template>
    <div class="pa-5">
    <v-layout clomun wrap justify-space-between="">
        <v-flex xs12 >
            <h1 class="fonte">Enviar</h1>
            <picture-input
            class="pl-3"
            :height="400"
            :width="1300"
            :zIndex="-1"
            ref="pictureInput"
            @change="onChanged"
            @remove="onRemoved"
            :removable="true"
            removeButtonClass="ui red button"
            accept="image/jpeg, image/png, image/gif"
            buttonClass="ui button primary"
            :customStrings="{
            upload: '<h1>Envie!</h1>',
            drag: 'Clique ou arraste e solte sua imagem aqui',
            tap: 'Clique aqui para selecionar uma foto <br>de sua galeria',
            change: 'Troque a Foto',
            remove: 'Remova a Foto',
            select: 'Selecione uma Foto',
            selected: '<p>Foto selecionada com sucesso!</p>',
            fileSize: 'Tamanho do arquivo excede o limite',
            fileType: 'Arquivo não suportado.',
            aspect: 'Landscape/Portrait'
            }"
            :hideChangeButton="true"
            ></picture-input>
            <v-btn class="ml-3 mt-3" color="fundo" @click="attemptUpload">Enviar</v-btn>
        </v-flex>
        <v-flex xs ma-3>
            <h1 class="fonte">Galeria</h1>
            <v-card >
                <v-container grid-list-sm fluid>
                <v-layout row wrap>
                    <v-flex
                    v-for="n in 9"
                    :key="n"
                    xs2
                    d-flex
                    >
                    <v-card flat tile class="d-flex">
                        <v-img
                        :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"
                        :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
                        aspect-ratio="1"
                        class="grey lighten-2"
                        >
                        <input type="text" style="width:1px;opacity:0" :ref="`link${n}`" :value="`https://picsum.photos/500/300?image=${n * 5 + 10}`" >
                        <v-tooltip bottom >
                            <template v-slot:activator="{ on }">
                               <v-btn fab small class="fundo" v-on="on" @click="copyText(n)">
                                    <v-icon>link</v-icon>
                                </v-btn>
                            </template>
                            <span class="subheading">Copiar link</span>
                        </v-tooltip>

                        <template v-slot:placeholder>
                            <v-layout
                            fill-height
                            align-center
                            justify-center
                            ma-0
                            >
                            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                            </v-layout>
                        </template>
                        </v-img>
                    </v-card>
                    </v-flex>
                </v-layout>
                </v-container>
            </v-card>
        </v-flex>
    </v-layout>

    </div>
</template>

<script>
import pictureInput from 'vue-picture-input'
export default {
    components: {
        pictureInput
    },
    data(){
        return{
            image: ''
        }
    },
    methods: {
        onChanged() {
            console.log("New picture loaded");
            if (this.$refs.pictureInput.file) {
            this.image = this.$refs.pictureInput.file;
            } else {
            console.log("Old browser. No support for Filereader API");
            }
        },
        attemptUpload() {
            console.log(this.image)
        },
        copyText (index) {
            //console.log(this.$refs[`link${index}`][0])
            this.$refs[`link${index}`][0].select()
            try {
            if ( document.execCommand('copy') ) {
                alert('copiou!')
            }
            } catch (err) {
            alert('nao deu pra copiar')
            }
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/user/push/Envios.vue